import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { electron } from 'lib-shared-electron';
import { useMemo } from 'react';
import { useAuthData } from 'utils/auth/authManager';
import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppSelector } from 'utils/redux/useAppSelector';
import styles from './profileDesktopAppLink.module.scss';
export const ProfileDesktopAppLink = () => {
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const organization = useAppSelector((state) => state.settings.organization.organization);
    const authData = useAuthData();
    const appProtocol = useMemo(() => {
        return `dixa://?refreshToken=${authData === null || authData === void 0 ? void 0 : authData.refresh_token}&subdomain=${organization === null || organization === void 0 ? void 0 : organization.subdomain}`;
    }, [authData, organization === null || organization === void 0 ? void 0 : organization.subdomain]);
    if (electron.isElectron() || isSmallScreen)
        return null;
    return (_jsx(Text.ExternalLink, Object.assign({ href: appProtocol, className: styles.root }, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, { children: ["Open Dixa App", _jsx(Icon, { name: "external-link" })] })) })));
};
